import { EnvVariables } from '@/services/EnvService'

const getRedirectUri = () => window.location.origin + '/callback'
const getLogoutRedirectUri = () => window.location.origin + '/' // must be an allowed oauth logout url

const getLogoutUrl = (envVars: EnvVariables) => {
  const logoutUrl = envVars.ANALYZE_OAUTH2_LOGOUT_URL
  if (!logoutUrl) return undefined
  const url = new URL(logoutUrl)
  url.searchParams.set('logout_uri', getLogoutRedirectUri())
  return url.toString()
}

export const getOidcSettings = (envVars: EnvVariables) => {
  const logoutUrl = getLogoutUrl(envVars)
  return {
    authority: envVars.ANALYZE_OAUTH2_AUTHORIZE_URL,
    responseType: envVars.ANALYZE_Response_Type,
    scope: envVars.ANALYZE_OAUTH2_SCOPES,
    client_id: envVars.ANALYZE_OAUTH2_CLIENT_ID,
    redirect_uri: getRedirectUri(),
    post_logout_redirect_uri: getLogoutRedirectUri(),
    loadUserInfo: false,
    automaticSilentRenew: true,
    metadata: {
      authorization_endpoint: envVars.ANALYZE_OAUTH2_AUTHORIZE_URL,
      token_endpoint: envVars.ANALYZE_OAUTH2_TOKEN_URL,
      ...(logoutUrl ? { end_session_endpoint: logoutUrl } : {}),
    },
  }
}
